import { useEffect, useState } from "react";
import api from "../lib/api";
import { displayName } from "../lib/anagConfig";
import { AlertTriangle, Loader2 } from "lucide-react";

// Avviso in tempo reale con i contatti simili già presenti mentre si digita il nominativo.
export default function SimilarContacts({ atype, nome, cognome, denominazione, onSelect, onCancel, testId = "similar" }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dismissed, setDismissed] = useState("");
  const key = [cognome, nome, denominazione].map((s) => (s || "").trim().toLowerCase()).join("|");
  const longest = Math.max(...[cognome, nome, denominazione].map((s) => (s || "").trim().length));

  useEffect(() => {
    if (!atype || longest < 2) { setItems([]); return; }
    let alive = true;
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/anagrafiche/${atype}/simili`, { params: { nome: nome || "", cognome: cognome || "", denominazione: denominazione || "" } });
        if (alive) setItems(data || []);
      } catch { if (alive) setItems([]); }
      finally { if (alive) setLoading(false); }
    }, 300);
    return () => { alive = false; clearTimeout(t); };
  }, [atype, key, longest]); // eslint-disable-line react-hooks/exhaustive-deps

  if (dismissed === key || (!items.length && !loading) || longest < 2) return null;
  if (!items.length) return <div className="text-xs text-slate-500 flex items-center gap-1.5" data-testid={`${testId}-loading`}><Loader2 className="h-3 w-3 animate-spin" /> Ricerca contatti simili…</div>;

  return (
    <div className="rounded-md border border-amber-500/50 bg-amber-500/10 p-3 space-y-2" data-testid={`${testId}-panel`}>
      <div className="flex items-center gap-2 text-sm font-semibold text-amber-300">
        <AlertTriangle className="h-4 w-4" /> Contatti simili già presenti ({items.length})
      </div>
      <div className="max-h-48 overflow-y-auto divide-y divide-slate-800 rounded border border-slate-800 bg-slate-950/40">
        {items.map((r) => (
          <div key={r.id} className="flex items-center justify-between gap-2 px-3 py-2" data-testid={`${testId}-item-${r.id}`}>
            <div className="min-w-0">
              <div className="text-sm text-slate-100 truncate">{displayName(r) || "—"}</div>
              <div className="text-[11px] text-slate-400 truncate">{[r.codice_fiscale || r.partita_iva, r.comune, r.cellulare || r.telefono].filter(Boolean).join(" · ") || "—"}</div>
            </div>
            <button type="button" onClick={() => onSelect?.(r)} data-testid={`${testId}-select-${r.id}`}
              className="shrink-0 text-xs font-semibold rounded-md px-2.5 py-1 bg-amber-500 text-[#0a0d14] hover:bg-amber-400 transition-colors">Seleziona esistente</button>
          </div>
        ))}
      </div>
      <div className="flex justify-end gap-2">
        <button type="button" onClick={() => onCancel?.()} data-testid={`${testId}-cancel`}
          className="text-xs rounded-md px-3 py-1.5 border border-slate-600 text-slate-200 hover:bg-slate-800 transition-colors">Annulla</button>
        <button type="button" onClick={() => setDismissed(key)} data-testid={`${testId}-continue`}
          className="text-xs rounded-md px-3 py-1.5 border border-amber-500/60 text-amber-300 hover:bg-amber-500/10 transition-colors">Continua a creare</button>
      </div>
    </div>
  );
}
